/* eslint-disable @reatom/unit-naming-rule */
import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { match } from 'ts-pattern'
import { useMemo } from 'use-memo-one'

import { CreateWalletFlow } from '@root/features/wallet/create-wallet/ui/create-wallet-flow'
import { walletsManagerModelAtom } from '@root/pages/wallet-manager/atoms'

import { reatomCreateWalletFlow } from '../../../atoms/reatom-create-wallet-flow'
import { WalletDetailsSection } from '../wallet-details-section'

type Props = {}

export const NewWallet: React.FC<Props> = () => {
  const { t } = useTranslation()
  const model = useMemo(() => reatomCreateWalletFlow(), [])
  const [managerModel] = useAtom(walletsManagerModelAtom)
  const [step, setStep] = useAtom(model.step)
  const clearSelectedWallet = useAction(managerModel.clearSelectedWallet)

  const handleBack = match(step)
    .with('acknowledgements', () => undefined)
    .with('seed-phrase', () => () => {
      setStep('acknowledgements')
    })
    .with('seed-phrase-confirm', () => () => {
      setStep('seed-phrase')
    })
    .exhaustive()

  return (
    <Root
      onBack={handleBack}
      title={t('wallet.create.new-wallet')}
      onClose={clearSelectedWallet}
    >
      <CreateWalletFlow model={model} />
    </Root>
  )
}

const Root = styled(WalletDetailsSection)``
